import {REPORT_FORMAT_EXCEL, REPORT_FORMAT_PDF} from '../localization/localizationKeys';

export const reportFormatsLocalized = {
    1: REPORT_FORMAT_PDF,
    2: REPORT_FORMAT_EXCEL,
};

export enum reportFormats {
    PDF = 1,
    Excel = 2,
}
